module.exports = __webpack_public_path__ + "r-v3/img/repeat.3f7f2bfe.svg";